import { api } from ".";

const account_uri = "/api/account";

export const login = (email, password) => {
  return api.post(`${account_uri}/login`, { email, password });
};

export const forgotPassword = (email) => {
  return api.post(`${account_uri}/forgot-password`, { email });
};

export const resetPassword = ({ email, token, newPassword }) => {
  return api.post(`${account_uri}/reset-password`, { email, token, newPassword });
};

export const logout = () => {
  localStorage.removeItem("accessToken");
};
